export const gridStyles = {
    height: "715px",
    width: "100%",

    "& .MuiDataGrid-columnHeader.keyword-header .MuiDataGrid-columnHeaderTitleContainer": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%!important",
    },

    "& .MuiDataGrid-columnHeader.keyword-header .MuiDataGrid-columnHeaderTitleContainerContent": {
        display: "flex",
        flex: 1,
    },

    "& .MuiDataGrid-columnHeader": {
        backgroundColor: "rgba(250, 251, 251)",
        borderLeft: "1px solid #e9ecee",
    },

    "& .keyword-header-wrapper": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },

    position: "relative",

    "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
        outline: "none !important",
    },

    "& .MuiDataGrid-cell": {
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        borderLeft: "1px solid #e9ecee",
    },

    "& .MuiDataGrid-columnHeaders": {
        borderBottom: "1px solid rgba(255,255,255,0.10)",
    },

    "& .MuiDataGrid-columnSeparator": {
        color: "rgba(255,255,255,0.12)",
        visibility: "visible",
    },

    "& .MuiDataGrid-cell:not(:last-of-type)": {
        borderRight: "1px solid rgba(255,255,255,0.06)",
    },

    "& .css-ly985t-MuiDataGrid-root .MuiTablePagination-toolbar": {
        color: "#919EAB!important",
    },

    "& .edited-row": {
        backgroundColor: "#f1ebfb!important",
    },

    "& .MuiDataGrid-row.row-invalid": {
        backgroundColor: "#ffe5e5 !important",
    },

    "& .MuiDataGrid-row:has(.Mui-error)": {
        backgroundColor: "#ffe5e5 !important",
    },

    "& .MuiDataGrid-cell:has(.Mui-error) .MuiDataGrid-editInputCell input": {
        backgroundColor: "#ffe5e5 !important",
        border: "0px !important",
    },

    "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
        color: "#919EAB!important",
    },

    "& .css-nnlark-MuiSelect-select-MuiInputBase-input.css-nnlark-MuiSelect-select-MuiInputBase-input.css-nnlark-MuiSelect-select-MuiInputBase-input": {
        borderRadius: "6px",
        border: "1px solid rgba(145, 158, 171, 0.20)",
        color: "#919EAB!important",
    },

    "& .MuiDataGrid-footerContainer .MuiTablePagination-actions .MuiIconButton-root": {
        color: "#919EAB!important",
    },

    "& .MuiDataGrid-footerContainer .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled": {
        color: "#d0d5da!important",
    },

    "& .MuiDataGrid-cell:focus": {
        outline: "none !important",
    },

    "& .MuiDataGrid-cell:focus-within": {
        outline: "none !important",
    },

    "& .MuiDataGrid-columnHeader:focus": {
        outline: "none !important",
    },

    ".css-ly985t-MuiDataGrid-root .MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader, .css-ly985t-MuiDataGrid-root .MuiDataGrid-row--borderBottom .MuiDataGrid-filler, .css-ly985t-MuiDataGrid-root .MuiDataGrid-row--borderBottom .MuiDataGrid-scrollbarFiller": {
        backgroundColor: "#fafbfb!important",
    },
};